"use client"

import { captureException } from "@sentry/nextjs"
import NextError from "next/error"
import { useEffect } from "react"

type Props = {
  error: Error & { digest?: string }
}

export default function GlobalError({ error }: Props) {
  useEffect(() => {
    console.error(error)
    captureException(error)
  }, [error])

  return (
    <html>
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  )
}
